// removed by extract-text-webpack-plugin
module.exports = {"panel-title-shared":"index__panel-title-shared___2cVxU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/SharedStatusIcon/index.less
// module id = 1225
// module chunks = 3